export const isEnumKey = <E extends Record<string, unknown>>(
  enumeration: E,
  value: string | number | symbol
): value is keyof E => value in enumeration;
